import { useMutation, useQueryClient } from '@tanstack/react-query';
import { findAction, invokeAction } from 'actions';
import { useAuthStatus } from 'features/auth';
import { invalidateProjectDetail, invalidateProjectLists } from './queries';
/** Shared mutationKey so consumers can detect in-flight unassignments via `useIsMutating`. */
export const UNASSIGN_AGENT_FROM_DL_PROJECT_KEY = ['unassignAgentFromDLProject'];
export function useUnassignAgentFromDLProject() {
    const authStatus = useAuthStatus();
    const user = authStatus.kind === 'authenticated' ? authStatus.user : null;
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: [...UNASSIGN_AGENT_FROM_DL_PROJECT_KEY],
        mutationFn: async ({ projectUUID, agentUUID }) => {
            if (!user)
                throw new Error('not authenticated');
            const action = findAction(user, 'unassignAgentFromDLProject');
            if (!action)
                throw new Error('unassignAgentFromDLProject action unavailable');
            const response = await invokeAction(action, user.token, {
                body: { projectUUID, agentUUID },
            });
            if (!response.ok)
                throw new Error(`unassignAgentFromDLProject returned ${response.status}`);
        },
        onSuccess: (_data, { projectUUID, agentUUID }) => {
            void queryClient.invalidateQueries({ queryKey: ['listAssignedAgents', user?.email, projectUUID] });
            void queryClient.invalidateQueries({ queryKey: ['listPotentialAssignees', user?.email, projectUUID] });
            invalidateProjectDetail(queryClient, user?.email, projectUUID);
            invalidateProjectLists(queryClient, user?.email);
            void queryClient.invalidateQueries({ queryKey: ['listAssignedDLProjects', user?.email, agentUUID] });
            void queryClient.invalidateQueries({ queryKey: ['listAssignableDLProjects', user?.email, agentUUID] });
            void queryClient.invalidateQueries({ queryKey: ['getAgent', user?.email, agentUUID] });
            void queryClient.invalidateQueries({ queryKey: ['listAgents', user?.email] });
        },
    });
}
